module.exports = __webpack_public_path__ + "72addccc65089d7b85429a50ffd8fa16.pdf";